// React
import React, { useEffect, useState } from "react";
// MUI
import { Card, Stack, Button, Container, Typography, Backdrop } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import InvoiceLine from "./InvoiceLine";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
import SpinService from "../../../services/SpinService";
import toast from "react-hot-toast";

import { Form, Formik } from "formik";
import { post, put } from "../../../services/FetchHelper";
import GoInLineTable from "../../../common/GoInLineTable/GoInLineTable";
import { invoiceLineTypes } from "./Invoice.utils";

const InvoiceLines = ({ invoiceHeader, invoiceHeaderId, invoiceLines, reload }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [invoiceLineState, setInvoiceLineState] = useState(invoiceLineTypes[invoiceHeader.fee_type].state);
    const [allInvoiceLines, setAllInvoiceLines] = useState([]);
    const [invoiceLineId, setInvoiceLineId] = useState(undefined);

    const addNew = () => {
        if (invoiceHeader.is_frozen) return;
        if (allInvoiceLines.find((item) => item.rowAction !== undefined && (item.rowAction === "new" || item.rowAction === "edit")) === undefined) {
            const nr = { ...invoiceLineTypes[invoiceHeader.fee_type].state, rowAction: 'new' };
            setInvoiceLineState(nr);
            if (allInvoiceLines === false) {
                setAllInvoiceLines([nr])
            } else {
                setAllInvoiceLines([...allInvoiceLines, nr])
            }
        }
    };

    const onAction = (item, action) => {
        if (invoiceHeader.is_frozen) return;
        if (action === "edit" && allInvoiceLines.find((item) => item.rowAction !== undefined && (item.rowAction === "new" || item.rowAction === "edit")) === undefined) {
            setInvoiceLineId(item.id);
            setInvoiceLineState(allInvoiceLines.find((row) => row.id === item.id));
            setAllInvoiceLines((prevFormFields) => prevFormFields.map(row => row.id === item.id ? { ...row, rowAction: 'edit' } : row));
        }
    }

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewInvoiceLine = values.id === undefined;
        values.invoice_header_id = invoiceHeaderId;
        const url = isNewInvoiceLine ? EntityConstants.INVOICE_LINES : EntityConstants.INVOICE_LINES + `/${values.id}`;
        const method = isNewInvoiceLine ? post : put;
        const response = await method(url, { invoice_line: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewInvoiceLine ? MessageContants.INVOICE_LINE_CREATED : MessageContants.INVOICE_LINE_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        setAllInvoiceLines(invoiceLines);
    }, [invoiceLines]);





    const [open, setOpen] = useState(false);

    const onClose = () => {
        setInvoiceLineState(invoiceLineTypes[invoiceHeader.fee_type].state);
        setOpen(false);
        reload();
    };

    // const onCalcChange = (invoiceLines) => {
    //     const lastRow = invoiceLines.reduce((accumulator, currentValue) => {
    //         return {
    //             area: "Total",
    //             // description: "Total",
    //             amount: currentValue.amount && (Number(accumulator.amount) + Number(currentValue.amount)).toFixed(2),
    //             credit_amount: currentValue.credit_amount && (Number(accumulator.credit_amount) + Number(currentValue.credit_amount)).toFixed(2),
    //             total_amount: currentValue.total_amount && (Number(accumulator.total_amount) + Number(currentValue.total_amount)).toFixed(2),
    //             vat_amount: currentValue.vat_amount && (Number(accumulator.vat_amount) + Number(currentValue.vat_amount)).toFixed(2),
    //         }
    //     }, {
    //         area: "Total",
    //         // description: "Total",
    //         amount: 0,
    //         credit_amount: 0,
    //         total_amount: 0,
    //         vat_amount: 0
    //     });
    //     const totalRows = invoiceLines.length > 0 && [...invoiceLines, lastRow];
    //     setInvoiceLines(prevState => ({ ...prevState, entries: totalRows }))
    // };

    // useEffect(() => {
    //     onCalcChange(invoiceLines)
    // }, [invoiceLines]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        Invoice Lines
                    </Typography>
                    {permissions.has(PermissionConstants.INVOICE_CREATE) && !invoiceHeader.is_frozen &&
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                            onClick={addNew}
                        >
                            New Line
                        </Button>
                    }
                </Stack>
                <Card>
                    <Formik
                        enableReinitialize
                        initialValues={invoiceLineState}
                        validationSchema={invoiceLineTypes[invoiceHeader.fee_type].schema}
                        onSubmit={(values) => handleSubmit(values)}
                    >
                        {({
                            values,
                            touched,
                            errors,
                            handleChange,
                            handleSubmit,
                        }) => (

                            <Form noValidate onSubmit={handleSubmit}>
                                <GoInLineTable
                                    tableHeads={invoiceLineTypes[invoiceHeader.fee_type].tableHeaders}
                                    tableDatas={allInvoiceLines}
                                    onAction={(row, action) => onAction(row, action)}
                                    editRowId={invoiceLineId}
                                    formElement={<InvoiceLine
                                        values={values}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        invoiceModel={invoiceHeader.fee_type}
                                        invoiceHeaderId={invoiceHeaderId}
                                        id={invoiceLineId}
                                        onClose={() => onClose()}
                                    />}
                                />
                            </Form>

                        )}
                    </Formik>

                    {/* <GoTable
                        search={false}
                        pagination={false}
                        tableHeads={tableConfig[invoiceHeader.fee_type]}
                        tableDatas={invoice_lines.entries}
                        totalCount={invoice_lines.total_count}
                        filter={filter}
                        onFilter={(filter) => setFilter(filter)}
                        onView={(row) => { setId(row.id); setOpen(true) }} /> */}
                </Card>
            </Container>
            {/* <Backdrop open={open} />
            {
                permissions.has(PermissionConstants.INVOICE_VIEW) && open && <GoDrawer
                    // minwidth="50%"
                    title="Invoice Line"
                    open={open}
                    onClose={() => onClose()}
                >
                    <InvoiceLine id={id} invoiceModel={invoiceHeader.fee_type} invoiceHeaderId={invoiceHeaderId} onClose={() => onClose()} />
                </GoDrawer>
            } */}

        </React.Fragment>
    );
}

export default InvoiceLines;